import React from "react";
import {
  getLabel,
  getLabelTagsArray,
  getLabelTagsWithDynamicInputs,
} from "../../../IpEMR/InspectionSummaries/constructTextFromValues";
import {
  cardiovascularOptions,
  neurologicalExaminationOptions,
  orthopedicOptions,
  respiratoryOptions,
  traumaOptions,
} from "../../../IpEMR/Options/clinicalImpressionOptions";
import { Descriptions } from "antd";

const ClinicalImpression = ({ details }) => {
  const constructClinicalImpressionSummaryItems = () => {
    const clinicalImpressionSummaryItems = [];

    if (
      details?.neurological_examination ||
      details?.neurological_examination_others
    ) {
      clinicalImpressionSummaryItems.push({
        key: "1",
        label: "Neurological System",
        children: (
          <>
            {getLabelTagsArray(
              neurologicalExaminationOptions,
              details?.neurological_examination
            )}
            {getLabelTagsWithDynamicInputs(
              details?.neurological_examination_others
            )}
          </>
        ),
      });
    }
    if (details?.respiratory_diagnosis || details?.respiratory_others) {
      clinicalImpressionSummaryItems.push({
        key: "2",
        label: "Respiratory",
        children: (
          <>
            {getLabelTagsArray(
              respiratoryOptions,
              details?.respiratory_diagnosis
            )}
            {getLabelTagsWithDynamicInputs(details?.respiratory_others)}
          </>
        ),
      });
    }
    if (details?.cardiovascular_diagnosis || details?.cardiovascular_others) {
      clinicalImpressionSummaryItems.push({
        key: "3",
        label: "Cardiovascular",
        children: (
          <>
            {getLabelTagsArray(
              cardiovascularOptions,
              details?.cardiovascular_diagnosis
            )}
            {getLabelTagsWithDynamicInputs(details?.cardiovascular_others)}
          </>
        ),
      });
    }
    if (details?.orthopedic_diagnosis) {
      clinicalImpressionSummaryItems.push({
        key: "4",
        label: "Orthopedic",
        children: getLabelTagsArray(
          orthopedicOptions,
          details?.orthopedic_diagnosis
        ),
      });
    }
    if (details?.trauma_diagnosis || details?.trauma_others) {
      clinicalImpressionSummaryItems.push({
        key: "5",
        label: "Trauma Diagnosis",
        children: (
          <>
            {getLabelTagsArray(traumaOptions, details?.trauma_diagnosis)}
            {getLabelTagsWithDynamicInputs(details?.trauma_diagnosis_others)}
          </>
        ),
      });
    }
    if (details?.clinical_diagnosis_notes) {
      clinicalImpressionSummaryItems.push({
        key: "6",
        label: "Clinical Diagonsis",
        children: getLabel(details?.clinical_diagnosis_notes),
      });
    }
    if (details?.final_diagnosis_notes) {
      clinicalImpressionSummaryItems.push({
        key: "7",
        label: "Final Diagnosis",
        children: getLabel(details?.final_diagnosis_notes),
      });
    }
    return clinicalImpressionSummaryItems;
  };

  return (
    <div>
      <Descriptions
        style={{ textAlign: "left" }}
        bordered={false}
        items={constructClinicalImpressionSummaryItems()}
        column={1}
        className="review-desc"
      />
    </div>
  );
};

export default ClinicalImpression;
